import React, { useState, useEffect } from "react";
import api from "../utils/api";

function SendNotification() {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [recipients, setRecipients] = useState([]); // IDs
  const [users, setUsers] = useState([]); // قائمة المستخدمين
  const [isGlobal, setIsGlobal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // تحميل قائمة المستخدمين (اختياري)
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await api.get("/users", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        setUsers(res.data);
      } catch (err) {
        console.error("❌ فشل تحميل المستخدمين", err);
      }
    };
    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = { title, message, isGlobal };
      if (!isGlobal) body.recipients = recipients;

      await api.post("/notifications", body, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      setSuccess(true);
      setTitle("");
      setMessage("");
      setRecipients([]);
      setIsGlobal(true);
    } catch (err) {
      console.error(err);
      alert("❌ فشل إرسال الإشعار");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto bg-white shadow p-6 rounded mt-10">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">✍️ إرسال إشعار</h2>

      {success && (
        <p className="text-green-600 mb-3 font-semibold">
          ✅ تم إرسال الإشعار بنجاح
        </p>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-bold mb-1">العنوان</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />
        </div>

        <div>
          <label className="block font-bold mb-1">الرسالة</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full border p-2 rounded h-32"
            required
          />
        </div>

        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="isGlobal"
            checked={isGlobal}
            onChange={(e) => setIsGlobal(e.target.checked)}
          />
          <label htmlFor="isGlobal" className="font-medium">
            إرسال لجميع المستخدمين
          </label>
        </div>

        {!isGlobal && (
          <div>
            <label className="block font-bold mb-1">اختر المستلمين:</label>
            <select
              multiple
              value={recipients}
              onChange={(e) =>
                setRecipients([...e.target.selectedOptions].map((o) => o.value))
              }
              className="w-full border p-2 rounded"
            >
              {users.map((u) => (
                <option key={u._id} value={u._id}>
                  {u.name} ({u.email})
                </option>
              ))}
            </select>
            <small className="text-gray-500">
              استخدم Ctrl/Command لتحديد أكثر من مستخدم
            </small>
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 transition w-full"
        >
          {loading ? "⏳ جاري الإرسال..." : "📩 إرسال الإشعار"}
        </button>
      </form>
    </div>
  );
}

export default SendNotification;
